var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotif({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 8,
    fill: "#FF4646",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4875 14.8375L16.9375 13.7375V12.5C16.9375 10.4375 15.425 8.7875 13.5 8.44375C13.5 8.44375 13.5 8.44375 13.5 8.375V7.6875C13.5 7.34375 13.1562 7 12.8125 7C12.4688 7 12.125 7.275 12.125 7.6875V8.375C12.125 8.375 12.125 8.375 12.125 8.44375C10.2 8.7875 8.6875 10.4375 8.6875 12.5V13.7375L8.06875 14.975C8.06875 14.975 8.06875 14.975 8.06875 15.0437C8 15.1125 8 15.1812 8 15.25C8 15.3188 8 15.3875 8.06875 15.4563V15.525C8.06875 15.525 8.06875 15.525 8.06875 15.5938L8.1375 15.6625C8.1375 15.6625 8.1375 15.7312 8.20625 15.7312C8.275 15.8 8.34375 15.8 8.34375 15.8687H8.4125C8.55 15.9375 8.61875 15.9375 8.6875 15.9375H10.75C10.75 17.175 11.85 18 12.8125 18C13.3625 18 13.9125 17.7937 14.2563 17.3813C14.6688 16.9688 14.875 16.4875 14.8062 15.9375H16.8687C17.2812 15.9375 17.5562 15.6625 17.5562 15.25C17.625 15.1125 17.5563 14.975 17.4875 14.8375ZM9.99375 14.15C10.0625 14.0812 10.0625 14.0125 10.0625 13.875H15.5625C15.5625 14.0125 15.5625 14.0812 15.6313 14.15L15.8375 14.5625H14.1875H11.4375H9.7875L9.99375 14.15ZM12.8125 9.75C14.325 9.75 15.5625 10.9875 15.5625 12.5H10.0625C10.0625 10.9875 11.3 9.75 12.8125 9.75ZM13.5 16.0063C13.5 16.2125 13.3625 16.35 13.2937 16.4187C13.1562 16.5562 13.0188 16.625 12.8125 16.625C12.5375 16.625 12.125 16.35 12.125 15.9375L13.5 16.0063Z",
    fill: "#FF5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.8e3c9cbd08543874a3ddfd4bdd877ca7.svg";
export { ForwardRef as ReactComponent };